'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  wcfUrl: process.env.WCFURL,
  superagentUrl: process.env.SUPERAGENT_URL,
  system: process.env.SYSTEM,
  admin: process.env.ADMIN,
  adminPassword: process.env.ADMIN_PWD,
  app: {
    title: '中艺艺品',
    description: '中艺艺品', // 工艺品定制、工艺品、大师作品、艺品体验、保真艺品
    head: {
      title: '中艺艺品',
      // titleTemplate: '艺品网:%s',
      meta: [{ name: 'description', content: '艺品网' }, { charset: 'utf-8' }]
    }
  }

}, environment);


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.js
 ** module id = 311
 ** module chunks = 0
 **/